<template>
<div class="wapper">
  <div class="newsSuccess mid-width clearfix">
    <dl class="slideBar">
      <dt>{{$route.query.parentId === '1' ? '典型案例' : '新闻资讯'}}</dt>
        <dd v-for="item in newsSuccessSubList" 
          :key="item.index" 
          @click="getNewsList(item.id)"
          :class="{'active': isActive === item.id}"
        >• {{item.name}}</dd>
    </dl>
    <div class="content">
      <div class="newsDetail_title">{{newDetail.title}}</div>
      <div class="sign">{{newDetail.author}}  {{newDetail.createTime | timeFormat}}</div>
      <div class="detail_text ft15">
        <div class="cont" v-html="newDetail.content"></div>        
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Api from '@/common/api/api'
import {timeFormat} from '@/common/js/dateTimeFormat.js'
  export default {
    data () {
      return {
        isActive: '',
        newsSuccessSubList: [],
        newDetail: {}
      }
    },
    created() {
      this.init(this.$route.query.parentId)
      this.getNewDetail(this.$route.query.id)
    },
    methods: {
      init(e) {
        Api.getCmscontentsubject({
          page: 1,
          limit: 20,
          parentId: e
        }).then((response) => {
          console.log(response)
          if (response.data.code === 0) {
            this.newsSuccessSubList = response.data.page.list
          }
        })
        .catch((error) => {
          console.log(error);
        })
      },
      getNewDetail(id) {
        Api.getNewDetail(id).then((response) => {
          if (response.data.code === 0) {
            this.newDetail = response.data.cmsContent
            this.isActive = response.data.cmsContent.subjectId
          }
        })
        .catch((error) => {
          console.log(error);
        })
      },
      getNewsList(id) {
        let toPath = this.$route.query.parentId === 1 ? '/successCase' : '/news'
        this.$router.push({
          path: toPath,
          query: {
            id: id
          }
        })
      }
    },
    filters: {        
        timeFormat: function (time) {
            return timeFormat(time);
        }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~@/common/css/common';
  @import '~@/common/css/news_success';
  .newsDetail_title {
    font-size: 28px;
    color: #000;
    margin: 40px 0 50px;
  }
  .sign {
    height: 30px;
    padding-left: 40px;
    background: url("d_img0.png") no-repeat;
    line-height: 30px;
    font-size: 14px;
    color: #aeaeae;
    margin-bottom: 60px;
  }
  .detail_text {
    margin-top: 40px;
    color: #333;
    .cont {                
        line-height: 30px;
        text-indent: 2rem;
        color: #3d464d;
    }
    p {
      line-height: 28px;
      font-size: 14px;
    }
    .align {
      text-indent: 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news/newsDetail.vue